import React from 'react'
import Papa from 'papaparse'
import { saveAs } from 'file-saver'
import { useWindowSize } from '../../helpers/hooks/hookWindowsSize'
import { useTranslation } from 'react-i18next'

interface utmValues {
  origin: string
  media: string
  campaign: string
  term: string
  content: string
}

interface DataItem {
  original_url: string
  short_url: string
  title: string
  domain: string
  tags: string[]
  has_qr: boolean
  utm: utmValues
  status: number
  tracking_count: number
  createdAt: string
}

interface ExportCsvProps {
  data: DataItem[]
  className?: string
}

const ExportCsv = ({ data, className }: ExportCsvProps) => {
  const sizeWidth = useWindowSize().width
  const { t } = useTranslation()

  const convertUtmToString = (utm: utmValues): string => {
    return JSON.stringify(utm)
  }

  const handleExportToCsv = () => {
    const dataCsv = data.map((item) => ({
      ...item,
      utm: convertUtmToString(item.utm),
      has_qr: item.has_qr ? 'codigo qr' : 'url',
      status:
        item.status === 1
          ? 'Activo'
          : item.status === 0
          ? 'Inactivo'
          : 'Estado Desconocido',
    }))

    const customColumnTitles = {
      utm: 'UTM',
      createdAt: 'Fecha',
      tracking_count: 'Clicks',
      has_qr: 'Tipo',
      original_url: 'URL original',
      short_url: 'URL corta',
      tags: 'Etiquetas',
      status: 'Estado',
      title: 'Titulo',
      domain: 'Dominio',
    }

    const csvData = dataCsv.map(
      ({
        original_url,
        short_url,
        title,
        domain,
        tags,
        has_qr,
        utm,
        status,
        tracking_count,
        createdAt,
      }) => ({
        [customColumnTitles.original_url]: original_url,

        [customColumnTitles.short_url]: short_url,
        [customColumnTitles.title]: title,
        [customColumnTitles.domain]: domain,
        [customColumnTitles.tags]: tags,
        [customColumnTitles.has_qr]: has_qr,
        [customColumnTitles.status]: status,
        [customColumnTitles.tracking_count]: tracking_count,
        [customColumnTitles.createdAt]: createdAt,
        [customColumnTitles.utm]: utm,
      })
    )

    const csv = Papa.unparse(csvData)
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
    saveAs(blob, 'urls.csv')
  }

  return (
    <button
      className={`button-transparent ${className} ${
        sizeWidth < 768 ? 'width-100' : 'width-auto'
      }`}
      type='submit'
      onClick={handleExportToCsv}
    >
      {`${t('EXPORT_CSV')}`}
    </button>
  )
}

export default ExportCsv
